let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dBjkU"), load("gQSWJ"), load("2S1L6"), load("c6MKV"), load("aZinD"), load("c0JsV")]).then(() => parcelRequire('cDSVd'));